var nodes = require("./nodes");

exports.Element = nodes.Element;
exports.element = nodes.element;
exports.text = nodes.text;
exports.readString = require("./reader").readString;
exports.writeString = require("./writer").writeString;



//////////////////
// WEBPACK FOOTER
// ./node_modules/mammoth-style/lib/xml/index.js
// module id = 673
// module chunks = 0